import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { API_CHECK_INVITATIONS_ACCEPT_PATH_KEY } from '@/swagger/constants/slash-keys';
import { API_POST_ACCEPT_INVITATION, KEY_POST_ACCEPT_INVITATION } from '../constants';
import { MOCK_RESPONSE_POST_ACCEPT_INVITATION } from '../mocks';

type RequestPostAcceptInvitation = GenericPost<
  typeof API_CHECK_INVITATIONS_ACCEPT_PATH_KEY
>['request']['body'];

export type CallParamsPostAcceptInvitation = RequestPostAcceptInvitation & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePostAcceptInvitation = GenericPost<
  typeof API_CHECK_INVITATIONS_ACCEPT_PATH_KEY
>['response']['body'];

type CallErrorPostAcceptInvitation = {
  message: string;
  code: number;
};

type CallSelectorsPostAcceptInvitation = unknown;

export const postAcceptInvitationCall = createGeneralCall<
  CallParamsPostAcceptInvitation,
  CallResponsePostAcceptInvitation,
  CallErrorPostAcceptInvitation,
  CallSelectorsPostAcceptInvitation
>({
  id: KEY_POST_ACCEPT_INVITATION,
  url: () => API_POST_ACCEPT_INVITATION,
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        token: payload.token,
        password: payload.password,
      };
    },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_ACCEPT_INVITATION : undefined,
});
